import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import GraphicDetailsForm from "../../../components/forms/setup/graphics/GraphicDetailsForm";
import { createSnackbarHelpers } from "../../../shared/snackbar";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function GraphicsViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [graphics, setGraphics] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const { showSuccess } = createSnackbarHelpers(addSnackbar);

  const getGraphics = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `graphics?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setGraphics(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createGraphic = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall(
      "graphics/create",
      payload,
      "multipart/form-data"
    );

    if (callResult.success) {
      showSuccess("Graphic added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getGraphics("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateGraphic = async function (values, index) {
    let callResult = await makePostApiCall(
      `graphics/${values.id}`,
      values,
      "multipart/form-data"
    );

    if (callResult.success) {
      showSuccess("Graphic updated");
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...graphics.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setGraphics({ ...graphics, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddGraphicSlideOver = (isEdit, graphic, index) => {
    setSlideOver({
      childComponent: (
        <GraphicDetailsForm
          graphic={graphic}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateGraphic(payload, index) : createGraphic(payload)
          }
          title={isEdit ? `Update ${graphic.name}` : "Add new graphic"}
        />
      ),
      open: true,
    });
  };

  const deleteGraphic = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteGraphic/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = graphics.data.filter((item) => item.id !== id);
      setGraphics({ ...graphics, data: newItems });

      showSuccess(callResult.data.message);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteGraphic = function (graphic, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteGraphic(graphic.id, index)}
          message={`Are you sure you want to delete  ${graphic.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddGraphicSlideOver,
    getGraphics,
    loading,
    graphics,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteGraphic,
  };
}
